import { z } from 'zod';
export const createMaterialFolderSchema = z.object({
    name: z.string().min(1).max(200),
    opposition_id: z.string().uuid(),
    parent_id: z.string().uuid().nullable().optional(),
});
export const updateMaterialFolderSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    parent_id: z.string().uuid().nullable().optional(),
});
export const registerMaterialSchema = z.object({
    folder_id: z.string().uuid(),
    opposition_id: z.string().uuid(),
    name: z.string().min(1).max(200),
    description: z.string().max(2000).optional(),
    file_path: z.string().min(1).max(1000),
    file_size_bytes: z.number().int().positive().max(52_428_800),
    mime_type: z.string().min(1).max(100),
});
export const updateMaterialSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    description: z.string().max(2000).nullable().optional(),
    folder_id: z.string().uuid().optional(),
});
export const grantPermissionSchema = z.object({
    student_id: z.string().uuid(),
    // Whether this grant also lets the student DOWNLOAD the material (still
    // watermarked). Defaults to false → view-only in the secure image viewer.
    // Also used by the folder-permission grant (cascades to contained materials).
    can_download: z.boolean().optional().default(false),
});
export const grantBulkPermissionsSchema = z.object({
    student_ids: z.array(z.string().uuid()).min(1).max(200),
    can_download: z.boolean().optional().default(false),
});
export const assignClassMaterialSchema = z.object({
    material_id: z.string().uuid(),
});
// Grant a folder to a PROFESSOR (user_profiles.id). No download flag: professors
// manage but never download the raw PDF.
export const grantFolderProfessorPermissionSchema = z.object({
    professor_id: z.string().uuid(),
});
//# sourceMappingURL=material.schema.js.map